import { graphql } from 'src/graphql';

export const InsightViews = graphql(`
  query InsightViews($code: String, $id: ID) {
    insight(code: $code, id: $id) {
      _id
      views {
        email
        count
        lastViewedAt
      }
    }
  }
`);
